import {
    LabelContainer,
    Label,
    RequiredToShowToPartnerSignifier,
    ValidationsList,
    FormFieldContainer,
    TextAreaControlShowingEdits,
    Button
} from '../../../components/Form/FormStyles';
import {EditedProject} from '../EditedProject';
import {ValidateControl} from '../../../components/Controls/ValidateControl';
import {useState} from 'react';
import {replaceNewLinesToSpaces} from '../../../record-editing';

export function ImpactStoryInProgressShortControl({
    project,
    setProjectAndValidate,
    disabled,
    generateShortImpactStory
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
    disabled?: boolean;
    generateShortImpactStory: (originalText: string) => Promise<string>;
}) {
    const [isGenerating, setIsGenerating] = useState(false);

    return (
        <FormFieldContainer>
            <LabelContainer>
                {!disabled && (
                    <ValidateControl
                        validated={project.ImpactStoryInProgressShortValidated.current}
                        disabled={project.ImpactStoryInProgress.notValidToShowPartner}
                        onChange={(e) =>
                            setProjectAndValidate({
                                ...project,
                                ImpactStoryInProgressShortValidated:
                                    project.ImpactStoryInProgressShortValidated.update(e.validated)
                            })
                        }
                    />
                )}
                <Label htmlFor="impactStoryInProgressShort">
                    Impact story - in progress (for PDF)
                </Label>
                <Button
                    disabled={disabled || isGenerating}
                    onClick={async () => {
                        setIsGenerating(true);
                        try {
                            const newText = await generateShortImpactStory(
                                project.ImpactStoryInProgress.current
                            );
                            setProjectAndValidate({
                                ...project,
                                ImpactStoryInProgressShort:
                                    project.ImpactStoryInProgressShort.update(
                                        replaceNewLinesToSpaces(newText)
                                    )
                            });
                        } finally {
                            setIsGenerating(false);
                        }
                    }}>
                    {isGenerating ? 'Generating...' : 'Generate with AI'}
                </Button>
            </LabelContainer>
            <TextAreaControlShowingEdits
                id="impactStoryInProgressShort"
                disabled={disabled}
                rows={4}
                value={project.ImpactStoryInProgressShort}
                onChange={(e) =>
                    setProjectAndValidate({
                        ...project,
                        ImpactStoryInProgressShort: project.ImpactStoryInProgressShort.update(
                            replaceNewLinesToSpaces(e.target.value)
                        )
                    })
                }></TextAreaControlShowingEdits>
            <ValidationsList validations={project.ImpactStoryInProgressShort.validations} />
        </FormFieldContainer>
    );
}
